import React from 'react';

export const MantenimientoUsuarios = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['admin', 'master'],
    routes: [{
        path: '/user-maintenance',
        component: React.lazy(() =>
            import ('./MantenimientoUsuariosList'))
    }]
};